import { render } from "./text.vue?vue&type=template&id=5412e6ac&scoped=true"
import script from "./text.vue?vue&type=script&lang=js"
export * from "./text.vue?vue&type=script&lang=js"

import "./text.vue?vue&type=style&index=0&id=5412e6ac&scoped=true&lang=css"

import exportComponent from "/Users/user/Desktop/Проекты/territory_transport/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5412e6ac"]])

export default __exports__